import React from 'react';

function Tree2Element(tree, overrideColor) {
    return (tree &&
        tree.map((node, i) => {
            var _a;
            const style = {};
            if (overrideColor) {
                if (node.tag === 'line') {
                    style.stroke = 'currentcolor';
                }
                if (['path', 'rect'].includes(node.tag)) {
                    if ((_a = node.attr) === null || _a === void 0 ? void 0 : _a.stroke) {
                        style.stroke = 'currentcolor';
                    }
                    else {
                        style.fill = 'currentcolor';
                    }
                }
            }
            return React.createElement(node.tag, Object.assign(Object.assign({ key: i }, node.attr), { style }), Tree2Element(node.child, overrideColor));
        }));
}
const IconBase = ({ color, size, data, overrideColor, }) => {
    return (React.createElement("svg", Object.assign({}, Object.assign({}, data.attr), { color: color, style: { width: size, height: size }, width: size, height: size }), Tree2Element(data.child, overrideColor)));
};

export { IconBase as I };
